export default "__VITE_ASSET__D86vkxd0__"